import VResponsive from './VResponsive'

export { VResponsive }
export default VResponsive



// WEBPACK FOOTER //
// ../../../src/components/VResponsive/index.ts